package site.shadadman.pages.worklog

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initWorklogPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/worklog.md", FrontMatterElement.Builder { addScalar("title", "worklog"); }))
}

@Page("/worklog/worklog")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun WorklogPage() {
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.IMPORTANT, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" In this section, I share a collection of reflections and key experiences from my professional journey within various corporate environments. Functioning much like a personal diary, these entries document the significant challenges I've encountered and the lessons learned along the way. While providing insight into my career path, I have taken care to ensure that all content remains respectful of confidentiality and does not expose any proprietary company information. enjoy!")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("companies") }) {
        org.jetbrains.compose.web.dom.Text("Companies")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/bit24cash/bit24cash") {
                org.jetbrains.compose.web.dom.Text("Bit24 Cash")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/marketmlm/marketmlm") {
                org.jetbrains.compose.web.dom.Text("MarketMLM")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/StrAIberry/StrAIberry") {
                org.jetbrains.compose.web.dom.Text("StrAIberry")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/SportsGameX/SportsGameX") {
                org.jetbrains.compose.web.dom.Text("SportsGameX")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/alfatechnology/alfatechnology") {
                org.jetbrains.compose.web.dom.Text("Alfa Technology")
            }
        }
    }
}
